import { Amplify } from 'aws-amplify';

const config = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID!,
      // OAuth Hosted UI configuration
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN!,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN!], // Must match /callback route
          redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT!],
          responseType: 'code' as const, // Authorization code flow
        },
      },
    },
  },
};

Amplify.configure(config);

export default config;
